import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/base.scss'
Vue.use(ElementUI);
import animated from 'animate.css';
Vue.use(animated);
import i18n from './lang'
Vue.config.productionTip = false;

// 按需加载
//引入 ECharts 主模块
let echarts = require('echarts/lib/echarts');
//按需引入echart折线图等组件
require('echarts/lib/chart/pie');
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/grid');
//vue全局注入echarts
Vue.prototype.$echarts = echarts;


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
